import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {FormService} from "../../form.service";

@Component({
  selector: 'app-atomka-calc',
  templateUrl: './atomka-calc.component.html',
  styleUrls: ['./atomka-calc.component.scss']
})
export class AtomkaCalcComponent implements OnInit {
  formStep = 0;
  greyed = false;
  @ViewChild('input_tel', {static: false}) telValue:ElementRef;
  @ViewChild('input_name', {static: false}) nameValue:ElementRef;
  formC = new FormGroup({
    name: new FormControl(''),
    tel: new FormControl(''),
    location: new FormControl(''),
    require: new FormControl(''),
    object: new FormControl('')
  });
  @Input('heading') heading = '';
  constructor( private formService: FormService) { }

  ngOnInit(): void {
  }

  submit() {
    if (this.formStep === 2) {
      let obj = {
        "name": this.formC.value.name,
        "tel": this.formC.value.tel,
        "objects": [722, 723, 724],
        "calc_type": 'fsetan-calc',
        "message": '',
        "selected": {
          "722": [this.formC.value.location],
          "723": [this.formC.value.require],
          "724": [this.formC.value.object],
        },
        "choices": {
          "722": ["Москве", "Московской области", "Другом регионе"],
          "723": ["Экспертиза промышленной безопасности", "Техническое освидетельствование", "Ликвидация/ консервация ОПО", "Паспортизация", "Идентификация", "Аудит", "Консультация", "Другое"],
          "724": ["Сеть газопотребления/котельная", "ТЭК/нефтебаза/химия", "Теплосеть", "Краны/подъемники", "Взрывчатые вещества", "Растительное сырье/элеваторы", "Металлургия", "Другое"],
        }
      };
      this.formService.sendReq(obj).subscribe((res) => {
        if (window['Comagic'] && window['Comagic'].addOfflineRequest) {
          window['Comagic'].addOfflineRequest({
            name: this.formC.value.name,
            email: '',
            phone: this.formC.value.tel,
            message: 'Заявка из калькулятора ФСЕТАН',
            calc_type: 'fsetan-sro',
          });
        }
      })
    }
  }
}
